<template>
	<div class='profile-sidebar'>
		<div v-for='(val , id) in values'
			:key='`"sidebar-profile-id-"${id}`'
			class='tab'
			:class='{ active: val.value===active}'
			@click='setValue(val.value)'
		>
			{{val.name}}
		</div>
	</div>
</template>
<script>
export default {
	name:    'SidebarTabs',
	props:   ['values', 'active'],
	methods: {
		setValue(val) {
			this.$emit('tabChange', val);
		}
	}
};
</script>
